import { styled } from '@mui/material/styles';

import { PinButton } from '../Button';

export const StyledBuildingNameContainer = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  '&:hover': {
    '& $pinButton': {
      opacity: 0.5,
    },
  },
}));

export const StyledPinButton = styled(PinButton)(() => ({
  opacity: 0,
  '&:hover': {
    opacity: 0.9,
  },
}));
